import { ICompleteResponse, getDietCalendarService } from "../services/getDietCalendarService";
import { useQuery } from "react-query";

export default function useDietCalendarQuery() {
    return useQuery<ICompleteResponse, Error>('dietCalendar', () => getDietCalendarService(), {
        refetchInterval: 1000 * 60 * 5
    });
}